import {
  Component,
  ChangeDetectionStrategy,
  InputSignal,
  input,
} from '@angular/core';
import { ModelForm } from '@shared/models';
import { PaginationForm } from '@shared/models/pagination.model';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIconButton,
        MatIcon,
        ReactiveFormsModule,
        FormsModule,
    ],
})
export class PaginatorComponent {
  readonly FIRST_PAGE = 1;

  total = input<number>(0);
  inputMode = input<'items' | 'pages'>('pages');

  paginationSizeList = input<number[]>([
    10,
    15,
    20,
    50,
    100,
  ]);

  get totalPages(): number {
    if (this.inputMode() === 'pages') {
      return this.total() || 1;
    }
    const size = this.paginationFormGroupRef()?.controls.pageSize.value || 10;
    return Math.ceil(this.total() / size) || 1;
  }

  paginationFormGroupRef =
    input<FormGroup<ModelForm<PaginationForm>>>(
      new FormGroup({
        pageNumber: new FormControl(this.FIRST_PAGE, { nonNullable: true }),
        pageSize: new FormControl(10, { nonNullable: true }),
      })
    );

  inputPage = this.FIRST_PAGE;
  page = this.FIRST_PAGE;

  paginate(page: number): void {
    const maxPage = this.totalPages;
    if (page >= this.FIRST_PAGE && page <= maxPage) {
      this.paginationFormGroupRef().controls.pageNumber.setValue(page);
      this.page = page;
      this.inputPage = page;
    } else {
      this.inputPage = this.page;
    }
  }

  onPageSizeChange(newSize: number) {
    const size = Number(newSize);
    if (size > 0) {
      this.paginate(1); // resetar para página 1
    }
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.paginate(page);
  }
}
